import React from 'react';

import { InferredProjectPopupContent as PopupContent } from '@atlassian/inferred-project-page/inferred-project-popup-content';
import type { InferredProjectPopupContentProps } from '@atlassian/rovo-platform-ui-components/inferred-project-popup-content';

import { useNavigationPolicy } from '@confluence/route-manager/entry-points/useNavigationPolicy.ts';

// Confluence only adds its in-app link rewriting to the page's popup.
export const InferredProjectPopupContent = (
	project: InferredProjectPopupContentProps,
): React.JSX.Element => {
	const { shimUrl } = useNavigationPolicy();
	return <PopupContent {...project} shimUrl={shimUrl} />;
};
